import { FormattedMessage } from 'react-intl'
import { Link } from '@tanstack/react-router'

import { Button } from '@gto/ui/button'
import { Typography } from '@gto/ui/typography'

import bg from '@/assets/images/suits.png'
import { sendGaEvent } from '@/gtag'

export const PokerRooms = () => {
  return (
    <section className="mt-12 flex flex-col items-center gap-16 px-8 py-12 sm:items-stretch sm:gap-12 sm:px-4">
      <div className="mx-auto max-w-[320px]">
        <img
          alt="Card Suits"
          loading="lazy"
          src={bg}
          style={{
            width: '100%',
            height: 'auto',
            display: 'block',
          }}
        />
      </div>
      <div className="max-w-[70%] text-center md:max-w-full">
        <Typography
          gutterBottom
          className="text-center"
          color="primary"
          component="h2"
          variant="h3"
        >
          <FormattedMessage id="home.pokerRooms.title" />
        </Typography>
        <Typography
          className="text-center"
          color="text.primary"
          component="h2"
          variant="body1"
        >
          <FormattedMessage id="home.pokerRooms.description" />
        </Typography>
      </div>
      <div>
        <Button
          className="sm:w-full"
          color="primary"
          component={Link}
          href="/app/deals"
          size="large"
          variant="contained"
          onClick={() => {
            sendGaEvent({
              event: 'home_find_deal',
            })
          }}
        >
          <FormattedMessage id="common.controls.findADeal" />
        </Button>
      </div>
    </section>
  )
}
